import { render } from "./SideModal.vue?vue&type=template&id=65e98864&scoped=true"
import script from "./SideModal.vue?vue&type=script&lang=js"
export * from "./SideModal.vue?vue&type=script&lang=js"

import "./SideModal.vue?vue&type=style&index=0&id=65e98864&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e98864"]])

export default __exports__